import React from "react";
import ProductScreen from "../../components/ProductScreen";

export default function Connect() {
  return (
    <ProductScreen
      heroImageSrc="/product-heroes/connect.png"
      eyebrow="Products / Connect"
      title="Connect"
      accent="#2453ff"
      description="Acquire and engage founders and partners at scale."
      bullets={[
        "Profiles, outreach, and network tooling in one place.",
        "Structured workflows for lead capture and qualification.",
        "Built for fast-moving partnership and acquisition teams.",
      ]}
      features={[
        { title: "Profiles", text: "Organize founders, partners, and leads into searchable views." },
        { title: "Outreach", text: "Track engagement, follow-ups, and coordinated campaigns." },
        { title: "Network", text: "Keep your relationships, notes, and signals together." },
      ]}
      ctaLabel="Start Connecting"
      summaryKicker="Connection Layer"
      summaryTitle="Bring acquisition, outreach, and relationship context into one workspace."
      summaryText="Connect is built for teams that need more than a contact list. It keeps the people, signals, and follow-ups around each conversation in one operational surface."
    />
  );
}
